import * as React from 'react';

const Umbrella24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m4.317 17.397 7.983-4.493 5.162 8.726c.498.85 1.85.065 1.327-.79l-5.143-8.693 7.96-4.48a.78.78 0 0 0 .288-1.065C19.116 1.916 13.49.668 8.113 3.509a4 4 0 0 0-.71.4C2.759 6.699.35 12.204 3.269 17.119a.78.78 0 0 0 1.049.278ZM5.61 7.342c-.277 2.586.715 5.61 1.197 6.9l-2.562 1.443c-1.38-2.858-.722-6.032 1.365-8.343m3.208-2.45c2.369-.936 5.723 2.135 7.392 4.053l-8.039 4.528c-.86-2.355-1.926-6.738.085-8.265.184-.11.374-.216.562-.316m3.238-1.178c3.233-.634 6.202.431 8.074 3.024l-2.558 1.44c-.89-1.043-3.08-3.4-5.516-4.464"
  }
));
Umbrella24.Size = 24;
Umbrella24.Title = "Umbrella";

export { Umbrella24 as default };
